export default __webpack_public_path__ + "static/media/add.11bd75ad.svg";